import { DATE_FORMAT } from "config/constants";
import { formatDate } from "utils/lib";
import {
    IAddUpdateZonalConfigtPageState,
    IFetchZonalConfigResponse,
    IWarehouseByStorageBlockMappingDto,
    IWarehouseCategory,
    IWarehouseStorageBlock,
    IZonalConfigPayload,
} from "../interfaces/Index";

export const normalizeFetchZonalConfigResponse = (
    res: Array<IFetchZonalConfigResponse>,
    pagination: number | boolean,
    isPaginatedRes: boolean
) => {
    let payload: any = {
        pagination: res.length === 50 ? pagination : false,
        isPaginatedRes,
    };
    payload.zonalConfigsData = res.map((zonalConfig: IFetchZonalConfigResponse) => {
        return {
            town: zonalConfig.town ? zonalConfig.town : "",
            id: zonalConfig.id ? zonalConfig.id : "",
            zoneName: zonalConfig.name ? zonalConfig.name : "",
            zone: zonalConfig.zone ? zonalConfig.zone : "",
            type: zonalConfig.type ? zonalConfig.type : "",
            status: zonalConfig.status ? zonalConfig.status : "",
            locationPolygonText: zonalConfig.locationPolygonText ? zonalConfig.locationPolygonText : "",
            createdAt: formatDate(zonalConfig.createdAt, DATE_FORMAT.DAY_MONTH_TIME12),
            createdBy: zonalConfig.createdBy,
            updatedAt: formatDate(zonalConfig.updatedAt, DATE_FORMAT.DAY_MONTH_TIME12),
            updatedBy: zonalConfig.updatedBy
        };
    });
    return payload;
};


export const normalizeZonalConfigCreatePayload = (req: IZonalConfigPayload): any => {
    let warehouseByStorageBlocks: IWarehouseByStorageBlockMappingDto[] = [];
    req.selectedWarehouseListWithStorageBlocks.forEach((warehouse) => {
        warehouse.storageBlocks.forEach((storageBlock)=>{
            warehouseByStorageBlocks.push( {
                    warehouseId: warehouse.id,
                    storageBlock: storageBlock.value
                }
            )
        })
    });

    const payload: IAddUpdateZonalConfigtPageState = {
        type: (req.type as any).value,
        name: req.zoneName,
        parentZoneId: (req.town as any).id || (req.zone as any).id,
        warehouseId: req.warehouse,
        warehouseCityId: (req.selectedCity as any).id,
        warehouseByStorageBlockMap: warehouseByStorageBlocks,
        channel: req.customerChannel?.value
    }

    return payload
}

export const normalizeZonalConfigUpdateReqPayload = (req: IZonalConfigPayload): any => {
    let warehouseByStorageBlocks: IWarehouseByStorageBlockMappingDto[] = [];
    req.selectedWarehouseListWithStorageBlocks.forEach((warehouse) => {
        warehouse.storageBlocks.forEach((storageBlock)=>{
            warehouseByStorageBlocks.push( {
                warehouseId: warehouse.id,
                storageBlock: storageBlock.value
            }
            )
        })
    });
    const payload: IAddUpdateZonalConfigtPageState = {
        name: req.zoneName,
        parentZoneId: (req.town as any).id || (req.zone as any).id,
        warehouseId: req.warehouse,
        warehouseCityId: (req.selectedCity as any).id,
        zoneStatus: req.status ? "ACTIVE" : "INACTIVE",
        warehouseByStorageBlockMap: warehouseByStorageBlocks,
        channel: req.customerChannel?.value
    }

    return payload

}

export const normalizeInActiveZonalConfigUpdateReqPayload = (req: IZonalConfigPayload): any => {
    const payload: IAddUpdateZonalConfigtPageState = {
        name: req.zoneName,
        zoneStatus: req.status ? "ACTIVE" : "INACTIVE",
    }
    return payload
}

export const normalizeWarehouse = (warehouse: any) => {
    return warehouse.map((type: any) => {
        return {
            id: type.id,
            value: type.id,
            label: type.name
        };
    });
};

export const normalizeZones = (warehouse: any) => {
    return warehouse.map((type: IWarehouseCategory) => {
        return {
            id: type.id,
            value: type.id,
            label: type.name,
        };
    });
};

export const normalizeWarehouseName = (warehouseName: any) => {
    return {
        id: warehouseName.id,
        value: warehouseName.id,
        label: warehouseName.name,
    };
};

export const normalizeIdValueResponse = (cities: any) => {
    return cities.map((city: any) => {
        return {
            ...city,
            key: city.id,
            value: city.id,
            title: city.name,
            label: city.name,
        };
    });
};

export const normalizeWarehouseStorageBlockResponse = (warehouses: any ) => {

    return warehouses.map((warehouse: any) => {
        return {
            id: warehouse.id,
            value: warehouse.id,
            label: warehouse.name,
           storageBlocks: warehouse.storageBlocks.map((it: string)=>{
               return {
                   value: it,
                   label: it
               }
           })
        };
    });

}
